"use strict";
exports.__esModule = true;
exports.ruby = void 0;
var client_1 = require("./faraday/client");
var client_2 = require("./native/client");
exports.ruby = {
    info: {
        key: 'ruby',
        title: 'Ruby',
        extname: '.rb',
        "default": 'native'
    },
    clientsById: {
        native: client_2.native,
        faraday: client_1.faraday
    }
};
//# sourceMappingURL=target.js.map